import React, { useEffect, useRef, useState } from 'react'
import { View } from 'react-native'
import TextM from '@common/components/text/TextM'
import { theme } from '@common/theme/theme'

/**
 * Simple countdown timer component
 * Note: Does not use SVG for mobile compatibility
 */
export function CountdownTimer({ seconds, onComplete, color = theme.colors.error, label }) {
    const [timeLeft, setTimeLeft] = useState(seconds)
    const timerRef = useRef(null)

    useEffect(() => {
        timerRef.current = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(timerRef.current)
                    if (onComplete) onComplete()
                    return 0
                }
                return prev - 1
            })
        }, 1000)

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current)
            }
        }
    }, [onComplete])

    const progress = (seconds - timeLeft) / seconds

    // Format time as MM:SS consistently
    const minutes = Math.floor(timeLeft / 60)
    const secs = timeLeft % 60
    const timeDisplay = `${minutes}:${secs.toString().padStart(2, '0')}`

    return (
        <View style={{ alignItems: 'center', marginVertical: 20 }}>
            <View
                style={{
                    width: 80,
                    height: 80,
                    borderRadius: 40,
                    backgroundColor: theme.colors.greyBg,
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderWidth: 4,
                    borderColor: color,
                }}
            >
                <TextM fontSize={20} fontWeight="Bold" color={color}>
                    {timeDisplay}
                </TextM>
            </View>
            <TextM
                fontSize={13}
                color={theme.colors.grey}
                style={{ marginTop: 12, textAlign: 'center' }}
            >
                {label || `Temps restant: ${timeDisplay}`}
            </TextM>
        </View>
    )
}
